import * as React from 'react';
import { useHistory } from 'react-router';
import Cookies from 'universal-cookie';
import { AppContext } from '../AppContext';
import { Button } from './Button';
import { ConfirmDialog } from './Dialogs';

/**
 * 「ログアウト」ボタン。押すと確認のダイアログを出し、「ログアウト」を選ぶとクッキーを消してログイン画面へ移る。
 * ヘッダーの右上とマイページで同じ動きにするため、どちらもこの部品を使う。
 */
export const LogoutButton: React.FC = function () {
  const appContext = React.useContext(AppContext);
  const history = useHistory();
  const [confirming, setConfirming] = React.useState(false);

  const logout = function () {
    const cookies = new Cookies();
    cookies.remove('auth-token');
    appContext.dispatch({ type: 'removeAccount' });
    history.push('/login');
  };

  return (
    <>
      <ConfirmDialog
        open={confirming}
        title="ログアウト"
        message={<p>ログアウトしますか？</p>}
        yesLabel="ログアウト"
        onYes={logout}
        onNo={() => setConfirming(false)}
      />
      <Button type="button" color="white" mini={true} onClick={() => setConfirming(true)}>
        ログアウト
      </Button>
    </>
  );
};
